import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
export var CarSideOutlineSVG = function CarSideOutlineSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M28 12h-4l-3.42-5a2 2 0 00-1.74-1H6.32a2 2 0 00-1.84 1.21l-2.26 4.36a2.08 2.08 0 00-.22.92V20a2 2 0 002 2 4 4 0 008 0h8a4 4 0 008 0 2 2 0 002-2v-6a2 2 0 00-2-2zM14 8h4.84l2.73 4H14zM6.32 8H12v4H4.25zM8 24a2 2 0 112-2 2 2 0 01-2 2zm16 0a2 2 0 112-2 2 2 0 01-2 2zm4-4h-.54a4 4 0 00-6.92 0h-9.08a4 4 0 00-6.92 0H4v-6h24z"
  }));
};
CarSideOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(CarSideOutlineSVG);